export function PageHeader({ title, description, ...props }) {
  return (
    <div className="border-b pb-2.5">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-semibold text-sm text-foreground">{title}</h1>
        </div>

        {props.children}
      </div>
    </div>
  )
}
